<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-help-menu-docs-preview></ui-help-menu-docs-preview></p>
<h1 id="description">Description</h1>
<p>Static help menu based on dropdown component, to use across applications.
Usually we will use it in application header.
Chat with us option is available if isIntercomAvailable input is set to true.
Launched features option is available if all required inputs are provided.</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">ui-help-menu</span>
    <span class="hljs-attr">accountSlug</span>=<span class="hljs-string">"campaign-manager-test"</span>
    <span class="hljs-attr">brandSlug</span>=<span class="hljs-string">"campaign-manager-rules"</span>
    <span class="hljs-attr">bannerflowUrl</span>=<span class="hljs-string">"https://sandbox-app.bannerflow.com"</span>
    [<span class="hljs-attr">isIntercomAvailable</span>]=<span class="hljs-string">"false"</span>
    (<span class="hljs-attr">showIntercom</span>)=<span class="hljs-string">"onIntercom()"</span>
&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-help-menu</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">accountSlug</td>
<td align="left">Account slug - required for launched features option</td>
</tr>
<tr>
<td align="left">brandSlug</td>
<td align="left">Brand slug - required for launched features option</td>
</tr>
<tr>
<td align="left">bannerflowUrl</td>
<td align="left">Url for B2 - required for launched features option</td>
</tr>
<tr>
<td align="left">isIntercomAvailable</td>
<td align="left">Is intercom widget available in application. True as default.</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">showIntercom</td>
<td align="left">Show intercom void event</td>
</tr>
</tbody></table>
